import { message } from "antd";
import React, { useState } from "react";
import { APICall } from '../Services/APICall';
import { GetUserInfo } from "../Services/GetUserInfo";
import { LoginAs } from '../pages/loginAs/LoginAs';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
    switch (action.type) {
        case "LOGIN_SUCCESS":
            return {
                ...state,
                isAuthenticated: true
            };
        case "SIGN_OUT_SUCCESS":
            return {
                ...state,
                isAuthenticated: false
            };
        case "SET_LOGIN_USER": {
            return {
                ...state,
                currentUser: action.payload
            };
        }
        case "SET_LOGOUT_USER": {
            return {
                ...state,
                currentUser: null
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

const INITIAL_STATE = {
    currentUser: null,
    isAuthenticated: !!sessionStorage.getItem("auth_token")
};

function UserProvider({ children }) {

    var [state, dispatch] = React.useReducer(userReducer, INITIAL_STATE);

    return (
        <UserStateContext.Provider value={state}>
            <UserDispatchContext.Provider value={dispatch}>
                {children}
            </UserDispatchContext.Provider>
        </UserStateContext.Provider>
    );
}

function useUserState() {
    var context = React.useContext(UserStateContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within a UserProvider");
    }
    return context;
}

function useUserDispatch() {
    var context = React.useContext(UserDispatchContext);
    if (context === undefined) {
        throw new Error("useUserDispatch must be used within a UserProvider");
    }
    return context;
}

// ###########################################################

async function loginUser(dispatch, emailaddress, password, history, setIsLoading, setError, setReturnMessage, setPatientDetails, setAuthCodeToken, setAllPatientData, setLoginAsDialogState, setConsentDialogState, setIsConsentDone) {

    setError(false);
    setIsLoading(true);

    if (!!emailaddress && !!password) {

        let data = {
            EmailAddress: emailaddress,
            Password: password,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        var response = await APICall('POST', 'auth/authenticate', data);
        if (response.success) {
            setError(null)
            setIsLoading(false);
            if (response.data.user.statusCode == null || response.data.user.statusCode == "Active" || response.data.user.statusCode == "Verified") {
                debugger
                if (response.success && response.data.user.relativeDetails.length > 0) {

                    setPatientDetails(response.data.user);
                    //setLoginAsDialogState(true);
                    let baseUrl = sessionStorage.getItem('server_api_url');
                    sessionStorage.clear();
                    sessionStorage.setItem('server_api_url', baseUrl)
                    sessionStorage.setItem('auth_token', response.data.authToken)
                    sessionStorage.setItem('user_info_patient', JSON.stringify(response.data))

                    dispatch({ type: 'LOGIN_SUCCESS' })
                    if (response.data.user.userTypeLogIn == 3) {
                        history.push('/app/patients')
                    } else {
                        history.push('/app/dashboard');
                    }

                } else {
                    debugger
                    let baseUrl = sessionStorage.getItem('server_api_url');
                    sessionStorage.clear();
                    sessionStorage.setItem('server_api_url', baseUrl)
                    sessionStorage.setItem('auth_token', response.data.authToken)
                    sessionStorage.setItem('user_info_patient', JSON.stringify(response.data))
                    sessionStorage.removeItem("login_attempts")

                    dispatch({ type: 'LOGIN_SUCCESS' })
                    if (response.data.user.userTypeLogIn == 3) {
                        history.push('/app/patients')
                    } else {
                        history.push('/app/dashboard');
                    }

                }
            }
            else {

                setPatientDetails(response.data.user);
                setAuthCodeToken(response.data.authToken);
                setAllPatientData(JSON.stringify(response.data));
                setIsConsentDone(false);
                setConsentDialogState(true);
            }
        }
        else {
            setError(true);
            setIsLoading(false);
            setReturnMessage(response.message);
        }

    } else {
        setError(true);
        setIsLoading(false);
        setReturnMessage(response.message);
        history.push("/login");
    }

}

// ########################################################### 
async function forgotPassowrd(emailaddress, history, setIsLoading, setError, setIsSuccess, setReturnMessage, setResetButtonDisalbed) {
    setError(false);
    setIsLoading(true);

    if (!!emailaddress) {
        let data = {
            EmailAddress: emailaddress
        };
        setResetButtonDisalbed(true);
        var response = await APICall('POST', 'auth/forgotPassword', data);
        if (response.success) {
            setError(false);
            setIsLoading(false);
            setIsSuccess(true);
            setReturnMessage(response.message);
        }
        else {
            setError(true);
            setIsSuccess(false);
            setIsLoading(false);
            setReturnMessage(response.message);
        }
    }
    else {
        setError(true);
        setIsSuccess(false);
        setIsLoading(false);
        setReturnMessage("Please enter email.");
    }
}
async function relativeValidateToken(token, setError, setIsAuthToken, setIsValidToken, setReturnMessage, usertype) {
    setError(false)
    setIsAuthToken(true);
    if (!!token) {
        let data = {
            Token: token,
            UserType: usertype
        };
        var response = await APICall('POST', 'auth/validateRelativeToken', data);
        if (response.success) {
            setError(false)
            setIsAuthToken(true);
            setIsValidToken(true);
            setReturnMessage(response.message);
        }
        else {
            setError(true);
            setReturnMessage(response.message);
            setIsAuthToken(true);
            setIsValidToken(false);
        }
    } else {
        setError(true)
        setIsAuthToken(true);
        setIsValidToken(false);
        setReturnMessage("The Link has been expired.");
    }
}

async function validateToken(token, setIsAuthToken, setError, setIsValidToken, setReturnMessage) {
    setError(false)
    setIsAuthToken(true);
    if (!!token) {
        let data = {
            Token: token
        };

        var response = await APICall('POST', 'auth/validateResetToken', data);
        if (response.success) {
            setIsAuthToken(true);
            setIsValidToken(true);
            setReturnMessage(response.message);
        }
        else {
            setIsValidToken(false);
            setIsAuthToken(true);
            setReturnMessage(response.message);
        }

    } else {
        setError(true)
        setIsValidToken(false);
        setIsAuthToken(true);
        //setReturnMessage("Password is reset. Pleae login.");
    }
}

async function resetPassword(dispatch, token, newPassword, confirmPassword, history, setIsLoading, setError, setIsSuccess, setReturnMessage) {
    setError(false);
    setIsLoading(true);
    if (!!token && !!newPassword && !!confirmPassword) {
        if (newPassword == confirmPassword) {
            let data = {
                Token: token,
                Password: newPassword,
                ConfirmPassword: confirmPassword
            };

            var response = await APICall('POST', 'auth/resetPassword', data);
            if (response.success) {
                setError(null)
                setIsLoading(false)
                //alert(response.message);
                setIsSuccess(true)
                setReturnMessage(response.message);
                message.success(response.message, 2);
                history.push('/app/login')
            }
            else {
                setError(true);
                setIsLoading(false);
                setReturnMessage(response.message);
                message.success(response.message, 2);
            }
        }
        else {
            setIsSuccess(false);
            setIsLoading(false);
            setReturnMessage("Passwords can't match");
            message.error(response.message, 2);
        }

    } else {
        setIsSuccess(true)
        setIsLoading(false);
    }
}

async function changePassword(dispatch, oldPassword, newPassword, confirmPassword, history, setIsLoading, setError, setIsSuccess, setReturnMessage) {

    let user = sessionStorage.getItem('user_info_patient');

    if (user != null) {
        let userdata = JSON.parse(user).user;
        let email = userdata.emailAddress;

        if (!!email && !!oldPassword && !!newPassword && !!confirmPassword) {

            if (newPassword == confirmPassword) {
                let data = {
                    EmailAddress: email,
                    OldPassword: oldPassword,
                    NewPassword: newPassword,
                    ConfirmPassword: confirmPassword
                };
                setIsLoading(true);
                var response = await APICall('POST', 'auth/changePassword', data);
                setIsLoading(false);
                if (response.success) {

                    setError(false);
                    setIsSuccess(true);
                    setReturnMessage(response.message);
                    // alert(response.message);
                    //history.push('/app/dashboard');
                }
                else {
                    setError(true)
                    setIsSuccess(true)
                    setReturnMessage(response.message);
                }
            }
            else {
                setIsSuccess(false);
                setIsLoading(false);
                setReturnMessage("Passwords can't match")
            }

        } else {
            setError(true)
            setIsLoading(false)
            setIsSuccess(false)
        }
    }
    else {
        setError(true)
        setIsLoading(false)
    }

}

function signOut(dispatch, history) {
    localStorage.removeItem("id_token");
    sessionStorage.clear();
    dispatch({ type: "SIGN_OUT_SUCCESS" });
    history.push("/login");
}

async function signUp(formData, setIsLoading, setError, setIsSuccess, setReturnMessage, setsignupButtonDisalbed) {

    setError(null);
    setIsLoading(true);

    if (formData.EmailAddress != "") { //&& formData.EmailAddress != undefined && formData.EmailAddress != null
        /* let data = {
             UserID: formData.GlucoUserId,
             FirstName: formData.FirstName,
             LastName: formData.LastName,
             EmailAddress: formData.EmailAddress,
             phoneNumber: formData.PhoneNumber,
             address1: formData.Address1,
             address2: formData.Address2,
             city: formData.City,
             zipCode: formData.ZipCode,
             patState: formData.patState,
             country: formData.Country,
             dateOfBirth: formData.DateOfBirth,
             genderCode: formData.GenderCode,
             weight: formData.Weight,
             weightUnit: formData.weightUnit,
             height: formData.Height,
             heightUnit: formData.heightUnit,
             userType: "1",
             timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
             lowerAftermeal: 90,
             lowerBeforeMeal: 90,
             upperAftermeal: 180,
             upperBeforeMeal: 180,
             uppermostAftermeal: 200,
             uppermost_beforemeal: 160,
             UserPhoto: formData.userPhoto,
             UserPhotoName: formData.userPhotoName
         };*/
        //console.log(data);
        setsignupButtonDisalbed(true);
        var response = await APICall('POST', 'auth/signUp', formData);
        if (response.success) {
            setError(false)
            setIsLoading(false)
            setIsSuccess(true)
            setReturnMessage(response.message);
        }
        else {
            setError(true);
            setIsLoading(false);
            setIsSuccess(false)
            setReturnMessage(response.message);
        }
    }
    else {
        setError(true);
        setIsLoading(false);
        setReturnMessage("Please enter email address");
    }
}

async function GetPatientRelativeDetails(patRelativeId, setError, setIsAuthToken, setState, setReturnMessage, setSmsDialog, setSaveLoading, usertype) {
    setError(false)
    setIsAuthToken(true);
    const effectiveUserType = usertype ?? 1;
    if (!!patRelativeId) {
        let data = {
            patientRelativeId: patRelativeId,
            UserType: effectiveUserType
        };
        var response = await APICall('POST', 'relative/GetPatientRelativeDetails', data);
        if (response.success && response.data != null) {
            setReturnMessage(response.message);
            setIsAuthToken(true);
            setState({
                patientRelativeId: response.data[0].patientRelativeId,
                name: response.data[0].patientName,
                email: response.data[0].email,
                relationship: response.data[0].relationShipCode,
                phone: response.data[0].phoneNumber,
                country: response.data[0].country,
                patientPhotoPath: response.data[0].patientPhotoPath
            });
            //if (response.success) {
            //    setSmsDialog(true);
            //}
            setSaveLoading(false);
        }
        else {
            setIsAuthToken(true);
            setReturnMessage(response.message);
        }
        //if (response.success) {
        //    setIsAuthToken(true);
        //    setIsValidToken(true);
        //    if (response.success) {
        //        setError(false);
        //    }
        //    else {
        //        setError(true);
        //    }
        //    setReturnMessage(response.message);
        //}
        //else {
        //    setIsAuthToken(true);
        //    setIsValidToken(false);
        //    setReturnMessage(response.message);
        //}
    } else {
        setError(true)
        setIsAuthToken(true);
    }
}

async function SendRelativeSMS(setError, props, setReturnMessage, setSMSCode) {
    setError(false)
    if (!!props.dataId) {
        let data = {
            PatientRelativeId: parseInt(props.dataId.patientRelativeId),
            phoneNumber: props.dataId.phone
        };
        //const formData = new FormData();
        //formData.append("PatientRelativeId", parseInt(props.patientRelativeId));
        //formData.append("phoneNumber", props.phoneNumber);

        var response = await APICall('POST', 'relative/sendSMS', data);
        if (response.success && response.data != null) {
            setReturnMessage(response.message);

            let code = response.message.split("||")[1];
            setSMSCode(code);
        }
        else {
            setReturnMessage(response.message);
        }
    } else {
        setError(true);
    }
}
async function UpdateRelativeSMSStatus(setError, props, setSubmitLoading, setReturnMessage) {
    setError(false)
    if (props.dataId) {
        let data = {
            PatientRelativeId: parseInt(props.dataId.patientRelativeId)
        };
        //const formData = new FormData();
        //formData.append("PatientRelativeId", parseInt(props.patientRelativeId));
        //formData.append("phoneNumber", props.phoneNumber);
        setSubmitLoading(true);
        var response = await APICall('POST', 'relative/updateSMSStatus', data);
        if (response.success && response.data != null) {
            setSubmitLoading(false);
        }
        else {
            setSubmitLoading(false);
            setReturnMessage(response.message);
        }
        setReturnMessage(response.message);
        setSubmitLoading(false);
    } else {
        setSubmitLoading(false);
        setError(true);
    }
}

function LandToDashboard(isConsentDone, PatientDetails, dispatch, history, authToken, allPatientData) {

    if (isConsentDone) {
        let baseUrl = sessionStorage.getItem('server_api_url');
        sessionStorage.clear();
        sessionStorage.setItem('server_api_url', baseUrl)
        sessionStorage.setItem('auth_token', authToken)
        sessionStorage.setItem('user_info_patient', allPatientData)
        sessionStorage.removeItem("login_attempts")

        dispatch({ type: 'LOGIN_SUCCESS' })
        history.push('/app/dashboard');
    }
}

// ###########################################################

export { UserProvider, useUserState, useUserDispatch, loginUser, forgotPassowrd, validateToken, relativeValidateToken, resetPassword, changePassword, signOut, signUp, GetPatientRelativeDetails, SendRelativeSMS, UpdateRelativeSMSStatus, LandToDashboard };